import { Box, Link, Typography } from "@mui/material";
import { useIsProspectListPage } from "../../hooks/useIsProspectListPage";

const baseStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: "#f7f7f7",
  minHeight: "8vh",
} as const;

const prospectsStyle = {
  position: "sticky",
  left: 0,
  width: "100vw",
  marginTop: "auto",
} as const;

function Footer() {
  const isProspectsPage = useIsProspectListPage();
  const style = isProspectsPage
    ? { ...baseStyle, ...prospectsStyle }
    : baseStyle;

  return (
    <>
      <Box sx={style} data-testid="footer">
        <Typography align="center" variant="body1">
          {`v${__APP_VERSION__} made with 💚 🌍`}
        </Typography>
        <Typography align="center" variant="body1">
          Any issues or requests? Raise it in{" "}
          <Link
            target="_blank"
            rel="noopener"
            href="https://earthly-org.atlassian.net/jira/software/c/projects/BUG/boards/5"
          >
            Jira
          </Link>
          .
        </Typography>
      </Box>
    </>
  );
}

export default Footer;
